import { gql } from '@apollo/client';
import _ from 'lodash';

export const MESSAGE_RACHEL_QUERY = gql`
  query MessageRachel($propertyId: String!, $applicationId: String!) {
    property(id: $propertyId) {
      id
      application(id: $applicationId) {
        id
        applicants {
          id
          isPrimaryApplicant
          contactInfo {
            firstName
          }
          status
          messageConversationId
        }
      }
    }
  }
`;

export function getMessageConversationId(primaryApplicant) {
  return _.get(primaryApplicant, `messageConversationId`, '');
}
